module.exports = __webpack_public_path__ + "static/media/egeos_image.dd3487fc.png";